import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneCancelOrHideButton } from '~/components/FileStatusTrackingPane/TaskPaneCancelOrHideButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type GetInProgressMetadata, type LibraryDeletionTask } from '~/store/tasks/types';

export type DeleteBoardPanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<LibraryDeletionTask>, 'libraryId'>;
  onCancel: () => void;
};

export const DeleteLibraryPanelInProgressPanelItem = memo(({ onCancel }: DeleteBoardPanelInProgressPanelItemProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <PaneItemTW
      avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
      title={<FileStatusTitle>{ui2026 ? 'Deleting library…' : 'Deleting library'}</FileStatusTitle>}
      buttons={<TaskPaneCancelOrHideButton onClick={onCancel} />}
    />
  );
});

DeleteLibraryPanelInProgressPanelItem.displayName = 'DeleteLibraryPanelInProgressPanelItem';
